import { Injectable } from '@angular/core';
import { LanguageFlag } from '../models/languageFlag';
import localeBr from '@angular/common/locales/pt';
import localeEsPy from '@angular/common/locales/es-PY';
import localeEn from '@angular/common/locales/en';
import { CountryEnum } from 'src/app/core/model/countryEnum';

@Injectable()
export class CountryContextService {
    public languageSelected: LanguageFlag;
    public languages: LanguageFlag[] = [
        {
            countryId: CountryEnum.Brasil,
            lang: 'pt-br',
            code: 'pt-br',
            name: 'Brasil',
            flag: './assets/media/svg/flags/255-brazil.svg',
            currency: 'BRL',
            locale: localeBr,
            decimalDigits: 2,
        },
        {
            countryId: 0,
            lang: 'en',
            code: 'en',
            name: 'EUA',
            flag: './assets/media/svg/flags/226-united-states.svg',
            currency: '$',
            locale: localeEn,
            decimalDigits: 2,
        },
        {
            countryId: CountryEnum.Paraguay,
            lang: 'es',
            code: 'es-PY',
            name: 'Paraguai',
            flag: './assets/media/svg/flags/041-paraguay.svg',
            currency: '₲',
            locale: localeEsPy,
            decimalDigits: 0,
        },
    ];

    constructor() {}

    public selectCountry(countryId: Number) {
        let find = this.languages.find((x) => x.countryId == countryId);
        this.languageSelected = find;
    }
}
